import { render } from "./OnHold.vue?vue&type=template&id=46ed11ac"
import script from "./OnHold.vue?vue&type=script&lang=ts"
export * from "./OnHold.vue?vue&type=script&lang=ts"

import "./OnHold.vue?vue&type=style&index=0&id=46ed11ac&lang=scss"
script.render = render

export default script